import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import { configureAmplify } from "./auth/amplify";

import App from "./App";
import AuthGate from "./auth/AuthGate";
import NoticeCard from "./components/ui/NoticeCard";
import "@fontsource-variable/inter";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

function renderError(message: string) {
  root.render(
    <div className="mx-auto max-w-xl px-6 pt-24">
      <NoticeCard title="Failed to start admin app">{message}</NoticeCard>
    </div>,
  );
}

(async () => {
  try {
    await configureAmplify();
  } catch (err) {
    renderError(err instanceof Error ? err.message : String(err));
    return;
  }
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthGate>
            <App />
          </AuthGate>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
})();
